import { render, staticRenderFns } from "./FormNewPromotionPage.vue?vue&type=template&id=8e7851ce&scoped=true&"
import script from "./FormNewPromotionPage.vue?vue&type=script&lang=js&"
export * from "./FormNewPromotionPage.vue?vue&type=script&lang=js&"
import style0 from "./FormNewPromotionPage.vue?vue&type=style&index=0&id=8e7851ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7851ce",
  null
  
)

export default component.exports